// Google API 文档：https://developers.google.com/tag-platform/security/guides/consent?hl=zh-cn
// 弹窗作出同意/拒绝操作前的默认值在 GaInstaller 中设置
import { storage } from 'base/utils/localStorage'
import { getCookie } from 'ava-util/dist/cookie';
import { COOKIE_COUNTRY, DEBUG_TRACKER } from 'base/config/constant'
import { isApp } from 'base/utils/app';
import { getParamInSearch } from 'ava-util/dist/request';
import { IConsentConfig, TConsentValue } from 'mod/track/GoogleConsent/interface';

declare const window: any;

function getStorageKey(country: string): string {
    return `GoogleConsent_${country}`;
}

// 数据存入 localStorage
export function setRecord(config: IConsentConfig) {
    const country = getCookie(COOKIE_COUNTRY);
    if (country) {
        storage.set(getStorageKey(country), JSON.stringify(config));
    }
}

// 获取 localStorage 中的数据
export function getRecord(): IConsentConfig | null {
    const country = getCookie(COOKIE_COUNTRY);
    if (!country) {
        return null;
    }

    const config = storage.get(getStorageKey(country));
    if (config) {
        try {
            return JSON.parse(config) as IConsentConfig;
        } catch (e) {
            console.log(e);
        }
    }
    return null;
}

// 读取 localStorage 中的数据，更新 Consent 数据
export function updateByRecord() {
    const record = getRecord();
    if (record) {
        updateConsent(record, false);
    }
}

// 发送数据
function track(action: string, config: Record<string, TConsentValue>) {
    if (getParamInSearch(DEBUG_TRACKER) === '1') {
        console.log(`-----Google Consent: ${action} -----`);
        if (config) {
            console.log(JSON.stringify(config, null, 4));
        }
    }
    if (window.gtag) {
        window.gtag('consent', action, config);
    }
}

// 获取 Consent 配置的值
function getConsentValue(allowed: boolean): TConsentValue {
    return allowed ? 'granted' : 'denied';
}

// 更新 Consent 配置
export function updateConsent(config: IConsentConfig, toRecord: boolean = true) {
    if (toRecord) {
        setRecord(config);
    }

    const preferencesValue = getConsentValue(config.preferences);
    const advertisingValue = getConsentValue(config.advertising);

    track('update', {
        'personalization_storage': preferencesValue,
        'analytics_storage': preferencesValue,
        'ad_storage': advertisingValue,
        'ad_user_data': advertisingValue,
        'ad_personalization': advertisingValue,
    });
}